import { useState } from 'react';
import { useLocation,useNavigate } from 'react-router-dom';
import { CountProvider } from '../../../Providers';
import InformationSection from '../LeftSection/LeftSectionBody/InformationSection/InformationSection';
import { useTheme } from '../../../Hooks';
import { SvgComponent } from '../../SvgComponent/SvgComponent';
import ToolTip from '../../ToolTip/Tooltip';
import "./PanelHorizontal.styles.css";
import { FUENTE_CUENTA, TIPO_COMPONENTE } from '../../../Utils';
import { Casos } from '../../Casos/Casos';
export function PanelHorizontal(props) {
    const [collapsed, setCollapse] = useState(true);
    const [modal, setModal] = useState(false);
    const [attachmentCount, setAttachmentCount] = useState(0);

    const classesNames = ["panelHorizontal", "bootstrapsio"];
    const { theme } = useTheme();
    const navigate = useNavigate();
    let IconClass = `panelHorizontalIconSlideIn`;
    if (collapsed) {
        classesNames.push("slideIn");
        IconClass = `fa-solid fa-angles-left`;
    } else {
        classesNames.push("slideOut");
        IconClass = `fa-solid fa-angles-right `;
    }

    const viewScreen = (type) => {
        var viewScreen;
        switch (type) {
            case FUENTE_CUENTA:
                viewScreen = "CuentaView";
                break;
            default:
                viewScreen = "null";
                break;
        }
        return viewScreen;
    };

    return (
        <div
            className={classesNames.join(" ")}
            style={{
                minHeight: props.simplebar
                    ? "80vh"
                    : `calc(100vh - ${theme.MAX_HEIGHT_HEADER})  - 250px`,
                maxHeight: props.simplebar
                    ? "80vh"
                    : `calc(100vh - ${theme.MAX_HEIGHT_HEADER})  - 250px`,
                overflowY: "hidden",
                overflowX: "hidden",
            }}
        >
            <div className="panel-horizontal-header">
                <div
                    onClick={() => {
                        setCollapse(!collapsed);
                    }}
                    style={{ padding: "0.5rem 0 0 0.3rem" }}
                >
                    {collapsed ? (
                        <SvgComponent
                            size="30px"
                            width="25"
                            height="25"
                            iconName="double-left"
                            style={{ cursor: "pointer" }}
                        />
                    ) : (
                        <SvgComponent
                            size="30px"
                            width="25"
                            height="25"
                            iconName="double-right"
                            style={{ cursor: "pointer" }}
                        />
                    )}
                </div>
                <hr style={{ marginTop: "0.5rem" }} />
            </div>

            <div
                style={{
                    maxHeight: props.simplebar
                        ? "70vh"
                        : `calc(100vh - ${theme.MAX_HEIGHT_HEADER}) - 250px`,
                    overflowY: "auto",
                    overflowX: "hidden",
                }}
            >
                {props?.PanelCollapsable?.sections &&
                    props?.PanelCollapsable?.sections
                        .sort((a, b) => {
                            var titleA = a.title.toUpperCase();
                            var titleB = b.title.toUpperCase();
                            return titleA < titleB ? -1 : titleA > titleB ? 1 : 0;
                        })
                        .map((child) => {
                            return (
                                <div key={child.title}>
                                    <div
                                        className="item icon-lateral mx-2 mt-3"
                                        onClick={() => {
                                            setCollapse(!collapsed);
                                        }}
                                    >
                                        <ToolTip
                                            message={child.title}
                                            className="mb-5"
                                            placement="left"
                                        >
                                            <div style={{ cursor: "pointer" }}>
                                                <SvgComponent
                                                    iconName={child.icon}
                                                    fill={theme.color1}
                                                    height={child.iconSize ?? "25px"}
                                                    width={child.iconSize ?? "25px"}
                                                />
                                            </div>
                                        </ToolTip>
                                        <span
                                            className="badge badge-light notify-badge "
                                            style={{
                                                backgroundColor: theme.color1,
                                            }}
                                        >
                      {child.tipo === TIPO_COMPONENTE.ATTACHMENTS
                          ? attachmentCount
                          : child.info?.length || 0}
                    </span>
                                    </div>
                                </div>
                            );
                        })}
            </div>

            <div
                className="panel-horizontal-body"
                style={{
                    maxHeight: `calc(100vh - ${theme.MAX_HEIGHT_HEADER} - 80px)`,
                    overflowY: "auto",
                    overflowX: "hidden",
                }}
            >
                {props.PanelCollapsable.sections &&
                    props.PanelCollapsable.sections
                        .sort((a, b) => {
                            var titleA = a.title.toUpperCase();
                            var titleB = b.title.toUpperCase();
                            return titleA < titleB ? -1 : titleA > titleB ? 1 : 0;
                        })
                        .map((section) => {
                            switch (section.tipo) {
                                case TIPO_COMPONENTE.ATTACHMENTS:
                                    return (
                                        <CountProvider
                                            key={section.title + section.tipo + "provider"}
                                        >
                                            <InformationSection
                                                key={section.title + section.tipo}
                                                title={section.title}
                                                icon={section.icon}
                                                modal={modal}
                                                onClick={() => setModal(true)}
                                                file
                                                disabled={section.disabled}
                                            >
                                            </InformationSection>
                                        </CountProvider>
                                    );

                                case TIPO_COMPONENTE.EVENTOS_FUTUROS:
                                    return (
                                        <CountProvider
                                            key={section.title + section.tipo + "provider"}
                                        >
                                            <InformationSection
                                                key={section.title + section.tipo}
                                                title={section.title}
                                                icon={section.icon}
                                                onClick={section.onClick}
                                                disabled={section.disabled}
                                            >
                                            </InformationSection>
                                        </CountProvider>
                                    );

                                case TIPO_COMPONENTE.EQUIPOS:
                                    return (
                                        <CountProvider
                                            key={section.title + section.tipo + "provider"}
                                        >
                                            <InformationSection
                                                key={section.title + section.tipo}
                                                title={section.title}
                                                icon={section.icon}
                                                onClick={section.onClick}
                                                disabled={section.disabled}
                                            >
                                            </InformationSection>
                                        </CountProvider>
                                    );

                                case TIPO_COMPONENTE.CASOS:
                                    return (
                                        <CountProvider
                                            key={section.title + section.tipo + "provider"}
                                        >
                                            <InformationSection
                                                key={section.title + section.tipo}
                                                title={section.title}
                                                icon={section.icon}
                                                onClick={section.onClick}
                                                disabled={section.disabled}
                                                info={section.isInfo}
                                                esCasoRelacionado={section.esCasoRelacionado}
                                                refresh={section.refresh}
                                                referencia={section.referencia}
                                            >
                                                <Casos
                                                    referencia={props.ReferenciaId}
                                                    list={section.info}
                                                />
                                            </InformationSection>
                                        </CountProvider>
                                    );
                                case TIPO_COMPONENTE.PERFILES:
                                    return (
                                        <CountProvider
                                            key={section.title + section.tipo + "provider"}
                                        >
                                            <InformationSection
                                                key={section.title + section.tipo}
                                                title={section.title}
                                                icon={section.icon}
                                                onClick={section.onClick}
                                                info
                                            >
                                            </InformationSection>
                                        </CountProvider>
                                    );
                                case TIPO_COMPONENTE.PROSPECTOS:
                                    return (
                                        <CountProvider
                                            key={section.title + section.tipo + "provider"}
                                        >
                                            <InformationSection
                                                key={section.title + section.tipo}
                                                title={section.title}
                                                icon={section.icon}
                                            >
                                            </InformationSection>
                                        </CountProvider>
                                    );
                                case TIPO_COMPONENTE.PROSPECTO:
                                    return (
                                        <CountProvider
                                            key={section.title + section.tipo + "provider"}
                                        >
                                            <InformationSection
                                                key={section.title + section.tipo}
                                                title={section.title}
                                                icon={section.icon}
                                                onClick={() => {
                                                    navigate(
                                                        `/${viewScreen(section.info.type)}?Id=${
                                                            section.info.idsec
                                                        }`
                                                    );
                                                }}
                                                disabled={!(section.info?.idsec || null)}
                                                info
                                            >
                                            </InformationSection>
                                        </CountProvider>
                                    );
                                case TIPO_COMPONENTE.OPORTUNIDADES:
                                    return (
                                        <CountProvider
                                            key={section.title + section.tipo + "provider"}
                                        >
                                            <InformationSection
                                                key={section.title + section.tipo}
                                                title={section.title}
                                                icon={section.icon}
                                                onClick={section.onClick}
                                                info={section.isInfo}
                                                disabled={section.disabled}
                                            >
                                            </InformationSection>
                                        </CountProvider>
                                    );
                                case TIPO_COMPONENTE.TAREAS_FUTURAS:
                                    return (
                                        <CountProvider
                                            key={section.title + section.tipo + "provider"}
                                        >
                                            <InformationSection
                                                key={section.title + section.tipo}
                                                title={section.title}
                                                icon={section.icon}
                                                onClick={section.onClick}
                                                disabled={section.disabled}
                                            >
                                            </InformationSection>
                                        </CountProvider>
                                    );

                                case TIPO_COMPONENTE.LLAMADAS:
                                    return (
                                        <CountProvider
                                            key={section.title + section.tipo + "provider"}
                                        >
                                            <InformationSection
                                                key={section.title + section.tipo}
                                                title={section.title}
                                                icon={section.icon}
                                                onClick={section.onClick}
                                                disabled={section.disabled}
                                            >
                                            </InformationSection>
                                        </CountProvider>
                                    );

                                case TIPO_COMPONENTE.CUENTA:
                                    return (
                                        <CountProvider
                                            key={section.title + section.tipo + "provider"}
                                        >
                                            <InformationSection
                                                key={section.title + section.tipo}
                                                title={section.title}
                                                icon={section.icon}
                                                onClick={null}
                                                disabled={true}
                                                info={section.isInfo}
                                            >
                                            </InformationSection>
                                        </CountProvider>
                                    );
                                case TIPO_COMPONENTE.CUENTAS:
                                    return (
                                        <CountProvider
                                            key={section.title + section.tipo + "provider"}
                                        >
                                            <InformationSection
                                                key={section.title + section.tipo}
                                                title={section.title}
                                                icon={section.icon}
                                                onClick={section.onClick}
                                                disabled={section.disabled}
                                                info={section.isInfo}
                                            >
                                            </InformationSection>
                                        </CountProvider>
                                    );

                                case TIPO_COMPONENTE.OPORTUNIDAD:
                                    return (
                                        <InformationSection
                                            key={section.title + section.tipo}
                                            title={section.title}
                                            icon={section.icon}
                                            onClick={() => {
                                                navigate(
                                                    `/${viewScreen(section.info.type)}?Id=${
                                                        section.info.idsec
                                                    }`
                                                );
                                            }}
                                            disabled={!(section.info?.idsec || null)}
                                            info
                                        >
                                        </InformationSection>
                                    );

                                case TIPO_COMPONENTE.CONTACTOS:
                                    return (
                                        <CountProvider
                                            key={section.title + section.tipo + "provider"}
                                        >
                                            <InformationSection
                                                key={section.title + section.tipo}
                                                title={section.title}
                                                icon={section.icon}
                                                onClick={section.onClick}
                                                info={section.isInfo}
                                                disabled={section.disabled}
                                            >
                                            </InformationSection>
                                        </CountProvider>
                                    );

                                case TIPO_COMPONENTE.COTIZACIONES:
                                    return (
                                        <CountProvider
                                            key={section.title + section.tipo + "provider"}
                                        >
                                            <InformationSection
                                                key={section.title + section.tipo}
                                                title={section.title}
                                                icon={section.icon}
                                                onClick={section.onClick}
                                                info={section.isInfo}
                                                esCotizacionButton={section.esCotizacionButton}
                                                esPanel={section.esPanel}
                                                referencia={section.referencia}
                                                refresh={section.refresh}
                                            >
                                            </InformationSection>
                                        </CountProvider>
                                    );

                                case TIPO_COMPONENTE.BALANCE:
                                    return (
                                        <CountProvider
                                            key={section.title + section.tipo + "provider"}
                                        >
                                            <InformationSection
                                                key={section.title + section.tipo}
                                                title={section.title}
                                                icon={section.icon}
                                                onClick={section.onClick}
                                                info={section.isInfo}
                                                addButtonIcon={"money"}
                                                addButtonLabel={"Visualizar Facturas"}
                                            >
                                            </InformationSection>
                                        </CountProvider>
                                    );
                                case TIPO_COMPONENTE.TOP_ITEM_VENDIDOS:
                                    return (
                                        <CountProvider
                                            key={section.title + section.tipo + "provider"}
                                        >
                                            <InformationSection
                                                key={section.title + section.tipo}
                                                title={section.title}
                                                icon={section.icon}
                                                info={section.isInfo}
                                            >
                                            </InformationSection>
                                        </CountProvider>
                                    );

                                case TIPO_COMPONENTE.RELOJ_TRABAJO:
                                    return (
                                        <CountProvider
                                            key={section.title + section.tipo + "provider"}
                                        >
                                            <InformationSection
                                                key={section.title + section.tipo}
                                                title={section.title}
                                                icon={section.icon}
                                                info={section.isInfo}
                                            >
                                            </InformationSection>
                                        </CountProvider>
                                    );

                                default:
                                    return (
                                        <InformationSection
                                            key={section.title + section.tipo}
                                            title={section.title}
                                            icon={section.icon}
                                        />
                                    );
                            }
                        })}
            </div>
        </div>
    );
}
